import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import {
  AppointmentsFilterAddedAction,
  AppointmentsFilterClearedAction,
} from './appointments-filter.actions';
import { AppointmentsFilterData } from '@sc/data-access-models';

@State<AppointmentsFilterData>({
  name: 'appointmentsFilter',
  defaults: null,
})
@Injectable({ providedIn: 'root' })
export class AppointmentsFilterState {
  @Action(AppointmentsFilterAddedAction)
  add(
    ctx: StateContext<AppointmentsFilterData>,
    { appointmentsFilter }: AppointmentsFilterAddedAction
  ): void {
    ctx.setState({ ...appointmentsFilter });
  }

  @Action(AppointmentsFilterClearedAction)
  clear(ctx: StateContext<AppointmentsFilterData>): void {
    ctx.setState(null);
  }
}
